'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import FolderNavCreateFolderBody from './FolderNavCreateFolderBody';
import FolderNavCreateFolderFooter from './FolderNavCreateFolderFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const FolderNavCreateFolder = ({
  createFolderOpen,
  folderName,
  onFolderNameChange,
  onFolderOpenChange,
  onSaveFolder
}) => {
  return /*#__PURE__*/_jsx(Popover, {
    open: createFolderOpen,
    placement: "bottom right",
    closeOnOutsideClick: true,
    onOpenChange: e => onFolderOpenChange(e.target.value),
    content: {
      body: /*#__PURE__*/_jsx(FolderNavCreateFolderBody, {
        folderName: folderName,
        onFolderNameChange: onFolderNameChange
      }),
      footer: /*#__PURE__*/_jsx(FolderNavCreateFolderFooter, {
        onFolderOpenChange: onFolderOpenChange,
        onSaveFolder: onSaveFolder
      })
    },
    children: /*#__PURE__*/_jsx(Button, {
      "aria-pressed": createFolderOpen,
      use: "transparent",
      onClick: () => onFolderOpenChange(!createFolderOpen),
      marginBlockEnd: "400",
      marginBlockStart: "200",
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.folderModal.create.createNewFolderButton"
      })
    })
  });
};
FolderNavCreateFolder.propTypes = {
  folderName: PropTypes.string.isRequired,
  createFolderOpen: PropTypes.bool.isRequired,
  onSaveFolder: PropTypes.func.isRequired,
  onFolderOpenChange: PropTypes.func.isRequired,
  onFolderNameChange: PropTypes.func.isRequired
};
export default FolderNavCreateFolder;